<template>
    <div class="dt-panelfooter clearfix" v-if="totalCount > 1">
        <div class="dataTables_info">
            Показано
            с {{((currentPage - 1) * perPage) + 1}}
            по <span v-if="(currentPage * perPage) < totalCount">{{currentPage * perPage}}</span>
            <span v-else>{{totalCount}}</span>
            из <b>{{totalCount}}</b> {{totalCount | pluralForm(['записи', 'записей', 'записей'])}}.
        </div>

        <div class="dataTables_paginate paging_simple_numbers" v-if="pageCount > 1">
            <ul class="pagination">

                <li class="paginate_button previous">
                    <router-link v-on:click.native="goPrev" :to="prevTo">
                        Предыдущая
                    </router-link>
                </li>

                <li
                        v-for="page in getPages()"
                        v-bind:key="'paginator-' + page"
                        class="paginate_button"
                        :class="{active: page === currentPage, disabled: page === 'sep-from' || page === 'sep-to'}"
                >
                    <router-link
                            v-on:click.native="goPage(page)"
                            v-if="page !== 'sep-from' && page !== 'sep-to'"
                            :to="getPage(page)">
                        {{page}}
                    </router-link>
                    <a v-if="page === 'sep-from' || page === 'sep-to'" href="javascript:void(0);">…</a>
                </li>


                <li class="paginate_button next">
                    <router-link v-on:click.native="goNext" :to="nextTo">
                        Следующая
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    import Helper from "../../../classes/Helper";

    export default {
        props: {
            currentPage: Number,
            pageCount: Number,
            perPage: Number,
            totalCount: Number,
            fromToLinks: {
                type: Number,
                default: 2,
            },
            queryName: {
                type: String,
                default: 'page',
            },
        },
        data() {
            return {
                prevTo: {},
                nextTo: {},
            };
        },
        watch: {
            'currentPage': function() {
                this.prevTo = this.prevPage();
                this.nextTo = this.nextPage();
            }
        },
        methods: {
            goPrev() {
                this.$router.push(this.prevTo);
                this.$emit('update');
            },
            goPage(page) {
                this.$router.push(this.getPage(page));
                this.$emit('update');
            },
            goNext() {
                this.$router.push(this.nextTo);
                this.$emit('update');
            },

            getRoute() {
                const route = {
                    name: this.$route.name,
                    params: this.$route.params,
                    query: this.$route.query,
                };

                return Helper.copyObject(route);
            },
            getPages() {
                const allPages = [];
                for (let page = 2; page < this.pageCount; page++) {
                    allPages.push(page);
                }
                let from, to;
                if (this.currentPage < this.fromToLinks * 2) {
                    from = 0;
                    to = from + 1 + this.fromToLinks * 2;
                } else {

                    from = this.currentPage - (this.fromToLinks * 2);
                    to = this.currentPage - 1 + (this.fromToLinks);

                    if (this.currentPage > (this.pageCount - (this.fromToLinks * 2))) {
                        to = this.pageCount - 2;
                        from = to - 1 - (this.fromToLinks * 2);
                    }
                }

                const pages = allPages.slice(from, to);
                if (from !== 0) {
                    pages.unshift('sep-from');
                }
                pages.unshift(1);
                if (this.pageCount > this.fromToLinks * 2 && to !== this.pageCount - 2) {
                    pages.push('sep-to');
                }
                pages.push(this.pageCount);
                return pages;
            },
            getPage(page) {
                const to = this.getRoute();
                to.query[this.queryName] = page;

                return to;
            },
            prevPage() {
                const to = this.getRoute();
                const page = this.currentPage - 1;
                if (page > 0) {
                    to.query[this.queryName] = page;
                } else {
                    to.query[this.queryName] = this.currentPage;
                }
                return to;
            },
            nextPage() {
                const to = this.getRoute();
                const page = this.currentPage + 1;
                if (page < this.pageCount) {
                    to.query[this.queryName] = page;
                } else {
                    to.query[this.queryName] = this.pageCount;
                }
                return to;
            },
        },
    }
</script>
